const initialState = {
  events: null,
  isLoading: false,
  hasLoadingError: false,
  errorMessage: '',
};

export default initialState;
